import gql from 'graphql-tag';

import { queryAgg } from '@confluence/query-preloader-tools';

export const preloadUnseenNotificationCount = () => {
	return queryAgg({
		// Matching the query name with next/packages/app-navigation/src/NotificationsButton.tsx
		// eslint-disable-next-line graphql-relay-compat/consistent-graphql-operation-naming
		query: gql`
			query NotificationsButtonQuery {
				notifications {
					unseenNotificationCount
				}
			}
		`,
	});
};
